import 'reflect-metadata'
import UserSettingsModel from '@models/user';
import { makeUrl } from '@utils/query';
import BaseComponent from '@base/component';
import { createApp, defineComponent } from 'vue';
import ErrorsComponentVue from '@components/errors/errors.vue'
import MsgsComponentVue from '@components/msgs/msgs.vue'

import './serialize.js'

var model = window.model = new UserSettingsModel();

var component = defineComponent({
    mixins: [BaseComponent],
    render: null,
    components: {
        errors: ErrorsComponentVue,
        msgs: MsgsComponentVue
    },
    data() {
        $('#refresh_captcha', this.$el).click(evt => this.refreshCaptcha(evt));
        model.country = 'US';

        return {
            url: window.location.href,
            model: model
        }
    },
    mounted: function() {
        $(".refresh-recaptcha").off().click(() => {
            if (typeof window.grecaptcha != "undefined" && window.grecaptcha) {
                window.grecaptcha.reset();
            }
        });
        
    },
    methods: {
        refreshCaptcha() {
            $.ajax({ url: 'refresh_captcha', success: data => this.refreshCaptchaDone(data), dataType: 'json' });
        },
        refreshCaptchaDone(data) {
            $(".captcha img").replaceWith(data.captcha);
        },
        changeDailyDate: function(evt) {
            // daily tip date selector
            var val = $(evt.target).val();
            if (val) {
                $("#dailytiplink").attr("href", "/signup/daily-handicapping-report-access/payment/?date=" + val);
            }
            else {
                $("#dailytiplink").removeAttr("href");
            }
        },
        submit(event) {
            event.preventDefault();
            event.stopPropagation();
            
            $("input[type=button],input[type=submit]", this.$el).prop('disabled', true);
            this.model.sync("submit");
            return false;
        }
    }
});

model.fetchData().then(data => {
    const app = createApp(component)
    app.mount("section#choose, section#info, section#cc, section#success, section#upgrade")
});
